<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="overview">
    <div class="item-block" v-for="(item, index) in showData" :key="index">
      <div class="item">
        <div class="icon" v-html="item.icon"></div>
        <div class="value">
          <span v-if="item.name">{{ item.name }}：</span>
          <span>{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { computed } from 'vue';
import { getOverviewData, _testOverviewData } from './index';

const showData = computed(() => {
  return getOverviewData(_testOverviewData, false, false, false);
});
</script>
<style lang="scss" scoped>
@import './index.scss';
.item-block {
  padding: 18px 0;
  margin: 0 100px;
}
.item {
  display: flex;
  align-items: center;
  min-height: 70px;

  .icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 100%;
    background: var(--theme-color-1);
    opacity: 1;
    position: relative;
    z-index: 2;
    ::v-deep {
      svg {
        --theme-color-1: #fff;
      }
    }
  }
  .value {
    padding: 18px 28px;
    font-size: 16px;
    box-sizing: border-box;
    color: #3e3e3e;
    border: 1px solid #d3d3d3;
    border-left: none;
    flex-grow: 1;
    background-color: #f5f5f5;
    position: relative;
    z-index: 1;
    &::before {
      content: '';
      width: 70px;
      height: calc(100% + 2px);
      position: absolute;
      left: -70px;
      top: -1px;
      background: var(--theme-color-1);
    }
  }
}
</style>
